<form ngNoForm [action]="inboundRedirectService.isInboundRedirect ? pointAndPayService.checkoutUrlTOL : pointAndPayService.checkoutUrl" method="POST">
    <!-- <input type="hidden" name="ReturnURL" [ngModel]="pointAndPayService.finishUrl"> -->
    <!-- <input type="hidden" name="CancelURL" [ngModel]="pointAndPayService.cancelUrl"> -->
    <!-- Will be bound manually on submission -->
    <textarea name="paramXML"></textarea>

    <input type="submit">
</form>